import axios from "axios"

const apiUrl = process.env.NEXT_PUBLIC_ZENDESK_API_URL

const client = axios.create({
  baseURL: apiUrl,
})

/* eslint-disable camelcase */
export interface ZendeskRequest {
  comment: {
    body: string
  }
  custom_fields?: Array<{ id: number; value: string }>
  requester: {
    email: string
    locale: string
    name: string
  }
  subject: string
}
/* eslint-enable camelcase */

export const createRequest = async (request: ZendeskRequest): Promise<void> => {
  client.post("/requests", {
    request,
  })
}
